import React, { useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { post, api } from "../../utils/api";
import InputField from "../../Components/Masters/InputField";
import SelectField from "../../Components/Masters/SelectField";
import FileField from "../../Components/Masters/FileField";
import Multiline from "../../Components/Masters/Multiline";
import EditDialog from "../../Components/Common/EditDialog";

function RaisedTicket({
  inputData,
  fetchData,
  id,
  data,
  isDrawerOpen,
  setIsDrawerOpen,
  setsnackOpen,
  fetchCardData,
}) {
  const [errors, setErrors] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});

  const initialState = {
    title: "",
    description: "",
    assignedTo: "",
    documents: [],
    raisedAgainst: "",
  };

  const [formData, setFormData] = useState(initialState);
  const [raisedAgainst, setRaisedAgainst] = useState("");

  const [verifybtn, setverifybtn] = useState({ email: false, phone: false });
  const [verify, setVerify] = useState({
    phone: false,
    email: false,
    emailMsg: "",
    phoneMsg: "",
  });
  const [TaskAltIcons, setTaskAltIcons] = useState({
    email: false,
    phone: false,
  });
  const [editDialog, setEditDialog] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "raisedAgainst") {
      if (value === "Vajra Support") {
        // Set "raisedAgainst" to "SuperAdmin" when value is "Portal"
        setFormData((prevState) => ({
          ...prevState,
          [name]: "Vajra Support",
          assignedTo: "",
        }));
        setRaisedAgainst("Vajra Support");
        // localStorage.removeItem("token");
      } else {
        // Set "raisedAgainst" to "Internal" for other values
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        setRaisedAgainst("Internal Support");
      }
    } else {
      // Update all other fields normally
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleClose = () => {
    const hasData = Object.values(formData).some((val) =>
      Array.isArray(val) ? val.length > 0 : String(val).trim() !== ""
    );
    if (hasData || uploadedFiles.length > 0) {
      setEditDialog(true);
    } else {
      setIsDrawerOpen(false);
      setErrors({});
      setUploadedFiles([]);
      setFormData(initialState);
      setRaisedAgainst("");
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const excludedFields = ["documents"];
    if (formData.raisedAgainst === "Vajra Support") {
      excludedFields.push("assignedTo");
    }
    inputData.forEach((input) => {
      // Skip validation for excluded fields
      if (excludedFields.includes(input.fieldName)) return;

      const value = formData[input.fieldName];
      console.log(input.fieldName, value);

      // Check if the field value is empty or invalid
      if (!value || value.trim() === "") {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }
    });
    setErrors({ ...errors, ...newErrors });
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    setverifybtn({});
    setVerify({});
    if (!validateForm()) return;
    const updatedFormData = { ...formData, documents: uploadedFiles };
    // Remove assignedTo if raisedAgainst is not "SuperAdmin"
    if (updatedFormData.raisedAgainst === "Vajra Support") {
      delete updatedFormData.assignedTo;
    }
    await post(`${api}/support/ticket/add`, { ...updatedFormData })
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        setIsDrawerOpen(false);
        setErrors({});
        setUploadedFiles([]);
        fetchData();
        fetchCardData();
        setFormData(initialState);
        setRaisedAgainst("");
      })
      .catch((err) => {
        console.log(err.response, err, "failed to add");
        if (err.response && err.response.data && err.response.data.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        }
      });
  };

  const renderInputField = (el) => {
    if (el.type === "select")
      return (
        <SelectField
          title={el.title}
          name={el.fieldName}
          value={raisedAgainst}
          handleChange={handleChange}
          options={el.option}
          url={el.url}
          errors={errors[el.fieldName]}
        />
      );
    if (
      el.type === "dependToraisedAgainst" &&
      formData?.raisedAgainst === "Internal Support"
    ) {
      // Handle select type with conditional logic for "Internal"
      return (
        <SelectField
          title={el.title}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          // options={el.option}
          url={el.url}
          errors={errors[el.fieldName]}
        />
      );
    }

    if (el.type === "file") {
      return (
        <FileField
          title={el.title}
          name={el.fieldName}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
        />
      );
    }
    if (el.type === "multiline")
      return (
        <Multiline
          title={el.title}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          fieldName={el.fieldName}
        />
      );
    else if (el.type === "text") {
      return (
        <InputField
          title={el.title}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );
    }
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "405px" }}>
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          width: "100%",
          p: 3,
          backgroundColor: "#fff",
          minHeight: "100vh",
        }}
      >
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? "Edit Ticket " : "Raise Ticket "}
        </Typography>
        {inputData.map((el) => (
          <div key={el.fieldName}>{renderInputField(el)}</div>
        ))}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  const handleExitAgree = () => {
    setEditDialog(false);
    setIsDrawerOpen(false);
    setFormData(initialState);
    setUploadedFiles([]);
    setRaisedAgainst("");
    setErrors({});
  };

  return (
    <>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent",
            // width: "400px",
            boxShadow: "none",
            overflowY: "auto",
          },
        }}
        anchor="right"
        open={isDrawerOpen}
        onClose={handleClose}
      >
        {list()}
      </Drawer>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
    </>
  );
}

export default RaisedTicket;
